import { Box, Icon, type IconProps } from "@chakra-ui/react";
import React from "react";

export function ReinforcementLearningIcon(props: IconProps) {
  return (
    <Icon width="24px" height="24px" fill="none" viewBox="0 0 24 24" {...props}>
      <Box
        as="path"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M7.5 18.5v-4m9 4v-4m-9-3v-6m9 6v-6m-4.5 13v-6m0-3v-4m-6.5 9h4m5 0h4m-8.5-5h4"
      />
      <rect width="18.83" height="18.83" x="2.585" y="2.585" stroke="currentColor" rx="1.748" />
    </Icon>
  );
}
